import { useEffect, useState } from 'react';
import { shortenAffiliateLink } from './branchIo';

export function useShortReferralLink(original: string, code?: string) {
  const [result, setResult] = useState({ original: '', code, link: '', error: '' });
  useEffect(() => {
    let cancelled = false;
    if (!original) return;
    shortenAffiliateLink(original, code).then(link => {
      if (!cancelled) setResult({ original, code, link, error: '' });
    }).catch(error => {
      if (!cancelled) setResult({ original, code, link: '', error: error?.message || 'Unable to create short link. Please reopen this affiliate to retry.' });
    });
    return () => { cancelled = true; };
  }, [original, code]);
  const current = result.original === original && result.code === code;
  return { link: current ? result.link : '', error: current ? result.error : '',
    loading: Boolean(original && (!current || (!result.link && !result.error))) };
}
